module.exports = __webpack_public_path__ + "static/media/ex5.cbc5ddc6.jpg";